module.exports = __webpack_public_path__ + "img/header-interaction.16ba30b3.png";